/* import __COLOCATED_TEMPLATE__ from './folder-title.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type Folder from 'embercom/models/content-service/folder';
import { type HighlightedResult } from 'embercom/objects/inbox/knowledge-base/search-result';
import { tracked } from 'tracked-built-ins';
import type IntlService from 'ember-intl/services/intl';
import { inject as service } from '@ember/service';

export interface Args {
  folder?: Folder;
  title?: string;
  showIcon?: boolean;
  createFolder?: boolean;
  truncateShort?: boolean;
  truncateLong?: boolean;
  isHeader?: boolean;
  highlightedTitleArray?: HighlightedResult[];
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
  Blocks: {
    default: [];
  };
}

export default class FolderTitle extends Component<Signature> {
  @tracked hasTruncatedText = true;
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get tooltipText() {
    if (this.args.folder?.get('isAiGenerated')) {
      return this.intl.t('knowledge-hub.conversational.conversation-extraction-settings.title');
    }
    return this.args?.title || this.args.folder?.get('title') || '';
  }

  @action handleMouseOver(event: MouseEvent) {
    this.hasTruncatedText = this.isTitleTruncated(event.target as HTMLElement);
  }

  isTitleTruncated(folder: HTMLElement) {
    let folderTitle = folder?.querySelector<HTMLElement>('[data-folder-title]');
    return folderTitle !== null && folderTitle?.scrollWidth > folderTitle?.offsetWidth;
  }

  get defaultFolderIcon() {
    return this.args.folder?.get('isAiGenerated') ? 'ai' : 'folder';
  }

  get useV2Components() {
    return this.appService.app.canUseFeature('team-knowledge-foundations-synced-content-v2');
  }

  get parentFolder() {
    let parentFolder = this.args.folder?.get('parentFolder');
    return !parentFolder ? this.intl.t('knowledge-hub.folders.heading') : parentFolder.get('title');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::Folders::FolderTitle': typeof FolderTitle;
  }
}
